import { api } from '../core';

export interface DocumentGetDownloadUnassignedResponse {
  documentName: string;
  downloadPath: string;
  downloadToken: string;
}

interface DocumentGetDownloadUnassignedProps {
  abortController?: AbortController;
  documentId: string | null;
  unassignedDocumentId: string | null;
}

const documentGetDownloadUnassignedApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDocumentGetDownloadUnassigned: builder.query<
      DocumentGetDownloadUnassignedResponse,
      DocumentGetDownloadUnassignedProps
    >({
      query: ({
        abortController = new AbortController(),
        documentId,
        unassignedDocumentId
      }: DocumentGetDownloadUnassignedProps) => ({
        url: `document/get-download/unassigned?${
          documentId ? `documentId=${documentId}` : `unassignedDocumentId=${unassignedDocumentId}`
        }`,
        method: 'GET',
        signal: abortController.signal
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getDocumentGetDownload in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetDocumentGetDownloadUnassignedQuery } = documentGetDownloadUnassignedApi;
